export enum ShuffleState {
    Heavy = "Heavy",
    Light = "Light",
    Off = "Off"
}
